import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { RolRequest } from '@shared/interfaces/request/rolRequest';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })
export class RolService {
  private _url = environment.apiBaseUrl + 'api/rol/';

  constructor(private _http: HttpClient) {}

  create(model: RolRequest): Observable<Response> {
    return this._http.post<Response>(this._url, model, httpOption);
  }

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  update(model: RolRequest): Observable<Response> {
    return this._http.put<Response>(this._url, model, httpOption);
  }

  delete(model: RolRequest): Observable<Response> {
    return this._http.request<Response>('delete', this._url, {
      body: model,
    });
  }
}
